import { z } from 'zod';
import { Asset } from '../types/Asset';
import { AssetSchema } from '../schemas/assetZodSchemas';
import { GetAssetListingSchema } from '../schemas/assetZodSchemas';

export function hydrateAssetItem(item: z.infer<typeof AssetSchema>): Asset {
    const asset: Asset = {
        id: item.id,
        fullpath: item.fullpath,
        mimeType: item.mimetype,
        type: item.type,
    };

    return asset;
}

export function transformAssetsResponse(data: unknown): Asset[] {
    // Parse and validate the data using the Zod schema
    const parsedResult = GetAssetListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error('Validation failed for getAssetListing:', parsedResult.error.errors);
        return [];
    }

    const edges = parsedResult.data.getAssetListing.edges;

    // Transform assets to Asset type
    return edges.map(({ node }) => {
        const item = node as z.infer<
            typeof GetAssetListingSchema
        >['getAssetListing']['edges'][number]['node'];

        return hydrateAssetItem(item);
    });
}
